
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class BookmarkIcon extends Vue {
  @Prop({ type: Boolean, default: false }) readonly bookmarked!: boolean;
  @Prop({ type: String, default: "w-4 h-4" }) readonly size!: string;
  @Prop({ type: String, default: "" }) readonly additionalClasses!: string;

  get iconClasses(): string {
    return `${this.size} ${this.additionalClasses}`.trim();
  }
}
